import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicles-filters',
  templateUrl: './vehicles-filters.component.html',
  styleUrls: ['./vehicles-filters.component.scss']
})
export class VehiclesFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
